export default class VideoListItemLayout {

  private _left: number;
  private _top: number;
  private _width: number;
  private _height: number;
  private _imageHeight: number;
  
  constructor(l: number, t: number, w: number, h: number, ih: number) {
    this._left = l;
    this._top = t;
    this._width = w;
    this._height = h;
    this._imageHeight = ih;
  }

  public get left(): number {
    return this._left;
  }
  public set left(value: number) {
    this._left = value;
  }
  public get top(): number {
    return this._top;
  }
  public set top(value: number) {
    this._top = value;
  }
  public get width(): number {
    return this._width;
  }
  public set width(value: number) {
    this._width = value;
  }
  public get height(): number {
    return this._height;
  }
  public set height(value: number) {
    this._height = value;
  }
  public get imageHeight(): number {
    return this._imageHeight;
  }
  public set imageHeight(value: number) {
    this._imageHeight = value;
  }

  public static getDefault() {
    return new VideoListItemLayout(0, 0, 0, 0, 0);
  }
}